import { useState } from 'react'
import { useHistory } from "react-router-dom";
import BreadCrumbs from '@components/Breadcrumbs'
import Button from '@components/Button'
import Icon from '@material-ui/core/Icon';
import Alert from '@material-ui/lab/Alert';
import Form from './Form';
import { apiClient } from '@services/api';
import { connect } from 'react-redux';

const Create = (props) => {
  document.title = `Cadastrar mensagem - ${process.env.REACT_APP_NAME}`
  const history = useHistory();
  const [message, setMessage] = useState({});
  const [initialDate, setInitialDate] = useState(null);
  const [finalDate, setFinalDate] = useState(null);
  const [exitDate, setExitDate] = useState(null);
  const [customersIds, setCustomersIds] = useState([]);
  const [exitId, setExitId] = useState('');
  const [reservations, setReservations] = useState(false);
  const [selectedVariables, setSelectedVariables] = useState([]);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const bradecrumbsConfig = [
    {
      title: 'Início',
      active: true,
      route: '/admin/central/mensagens'
    },
    {
      title: 'Nova mensagem',
    }
  ]

  const changeState = (ev) => {
    if (ev.target.name === "template_id") {
      setSelectedVariables([])
    }
    if (ev.target.name === "status" && ev.target.value === "true") {
      setMessage(
        {
          ...message,
          status: true
        }
      )
    } else if (ev.target.name === "status" && ev.target.value === "false") {
      setMessage(
        {
          ...message,
          status: false
        }
      )
    } else {
      setMessage(
        {
          ...message,
          [ev.target.name]: ev.target.value
        }
      )
    }
  }

  const changeValueRadio = (ev) => {
    setInitialDate(null)
    setFinalDate(null)
    setExitDate(null)
    setExitId('')
    setReservations(false)
    setCustomersIds([])
    setMessage(
      {
        ...message,
        type: ev.target.value
      }
    )
  }

  const messagesVariables = {
    "nome_cliente": "customer_name",
    "endereço": "customer_address",
    "consultor": "seller_name",
    "horário_saída": "exit_time",
    "os/referência": "reference",
    "nome_passeio": "tour_name",
    "data_passeio": "tour_date",
    "tipo_transfer": "transfer_type",
    "horário_vôo": "transfer_flight_time",
    "nome_guia": "guide_name",
    "nome_motorista": "driver_name",
    "link_voucher": "link_voucher",
    "link": "link",
  }

  const submitMessage = (ev) => {
    ev.preventDefault();
    setIsLoading(true);

    let form = {}
    for (let index = 0; index < ev.target.length; index++) {
      if (ev.target[index].files) {
        const arquivos = ev.target[index].files;
        form[ev.target[index].name] = arquivos;
      }
    }

    if (initialDate == null && finalDate == null && exitDate == null && customersIds.length == 0) {
      setError(true);
      setIsLoading(false);
      setErrorMessage("Preencha os campos necessários")
      setTimeout(() => { setError(false) }, 4000);
    } else {
      let variablesValues = []
      selectedVariables.forEach((element, index) => {
        variablesValues.push(messagesVariables[element])
      });
      if (message.type === 'saida') {
        apiClient
          .httpInstance.post("/central/save_message_customers", {
            template_id: message.template_id,
            exit_id: message.exit_id,
            customers_ids: customersIds,
            variables: variablesValues,
            /*link: message.link,
            image : form['image'],
            video : form['video'],
            document: form['file']*/
          })
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              setOpenModal(true)
              setIsLoading(false);
              //history.push('/admin/central/mensagens');
            }
          })
          .catch(error => {
            if (error) {
              setError(true);
              setIsLoading(false);
              setErrorMessage(error.response.message || "Erro inesperado, tente novamente mais tarde")
              setTimeout(() => { setError(false) }, 4000);
            }
          });
      }
      //console.log(form['video'])
      if (message.type === 'clientes') {

        const formData = new FormData()

        if (form['image'].length > 0) {
          const imageFile = form['image'][0]
          formData.append('image', imageFile)
        }
        if (form['video'].length > 0) {
          const videoFile = form['video'][0]
          formData.append('video', videoFile)
        }
        if (form['document'].length > 0) {
          const documentFile = form['document'][0]
          formData.append('document', documentFile)
        }

        customersIds.forEach(c => {
          formData.append('customers_ids[]', c)
        });

        variablesValues.forEach(v => {
          formData.append('variables[]', v)
        });

        formData.append('template_id', message.template_id)
        message?.link && formData.append('link', message.link)

        apiClient
          .httpInstance.post("/central/save_message_customers", formData, { headers: { "Content-Type": "multipart/form-data" } })
          /*{
            template_id: message.template_id,
            customers_ids: customersIds,
            variables: variablesValues,
            link: message.link,
            image: form['image'],
            video: form['video'],
            document: form['file']
          })*/
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              setOpenModal(true)
              setIsLoading(false);
              //history.push('/admin/central/mensagens');
            }
          })
          .catch(error => {
            if (error) {
              setError(true);
              setErrorMessage(error.response.message || "Erro inesperado, tente novamente mais tarde")
              setTimeout(() => { setError(false) }, 4000);
            }
          });
      }
      if (message.type === 'reservas') {
        apiClient
          .httpInstance.post("/central/save_message_period", {
            template_id: message.template_id,
            from_date: initialDate,
            to_date: finalDate,
            variables: variablesValues,
            reservations: true
          })
          .then(response => {
            if (response.status === 200 || response.status === 201) {
              setIsLoading(false);
              history.push('/admin/central/mensagens');
            }
          })
          .catch(error => {
            if (error) {
              setError(true);
              setIsLoading(false);
              setErrorMessage(error.response.message || "Erro inesperado, tente novamente mais tarde")
              setTimeout(() => { setError(false) }, 4000);
            }
          });
      }
    }
  }

  return <>
    <BreadCrumbs items={bradecrumbsConfig} />
    {error && (
      <Alert className="mb-5" variant="filled" severity="error">
        {errorMessage}
      </Alert>
    )}
    <div className="px-7 pt-6">
      <div className="flex items-center justify-between mt-2 text-2xl text-blue">
        <span>Nova mensagem</span>
        <Button
          textcolor="#e8f0fb"
          padding="6px 15px"
          width="200"
          variant="outlined"
          onClick={() => history.push('/admin/central/mensagens')}
          bgColor="transparent"
        >
          <Icon className="mr-2">
            arrow_back
          </Icon>
          Cancelar
        </Button>
      </div>
      <Form
        {...props}
        isLoading={isLoading}
        submit={submitMessage}
        message={message}
        isEditing={false}
        changeState={changeState}
        changeValueRadio={changeValueRadio}
        initialDate={initialDate}
        finalDate={finalDate}
        exitDate={exitDate}
        setExitId={setExitId}
        setReservations={setReservations}
        customersIds={customersIds}
        setInitialDate={setInitialDate}
        setFinalDate={setFinalDate}
        setExitDate={setExitDate}
        setCustomersIds={setCustomersIds}
        selectedVariables={selectedVariables}
        setSelectedVariables={setSelectedVariables}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
    </div>
  </>
}

const mapStateToProps = state => {
  return {
    user: state.user
  }
}

export default connect(
  mapStateToProps
)(Create);
